module.exports = __webpack_public_path__ + "static/media/logo_200.ae5740e8.png";